
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUserData } from '@/types/user-types'
import { UserService } from '@/services'
import { roleOptions } from '@/constants/role'

/**
 * 
 * @prop users      用户列表数据
 * @prop type       展示类型
 * 
*/
@Component({
    name: 'UserTable',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private users!: IUserData[]
    @Prop({ required: true }) private refreshUsers!: () => void
    @Prop({ default: 'list' }) private type!: String

    private roleOptions = roleOptions

    // 修改联系状态 / 账号类型
    private async onUpdateInfo(user:any, value: Record<string, any>) {
        const params = {
            id: user.id,
            ...value
        }
        const result = await UserService.updateUser(params)
        if (result.status === 200) {
            this.$message.success('修改成功')
            if ('role' in value) {
                user.role = value.role
            }
        } else {
            this.$message({ type: 'error', message: result.message })
        }
    }

    private onRemove(user: any) {
        this.$confirm('确认删除此用户?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const result = await UserService.updateUser({ id: user.id,  role: user.role, password: '' })
            if (result.status === 200) {
                this.$message.success('删除成功')
                this.refreshUsers()
            } else {
                this.$message({ type: 'error', message: result.message })
            }
        }).catch(() => {
            this.$message({ type: 'info', message: '已取消操作' })         
        })
    }

    private onEdit(user: any) {
        window.open('/permission/user/' + user.id)
    }
}
